import { createRoutine, bindRoutineToReduxForm } from 'redux-saga-routines';

export const submitFormRoutine = createRoutine('SUBMIT_MODAL_AUTHORIZED_FORM');
export const submitFormHandler = bindRoutineToReduxForm(submitFormRoutine);
